import { Button } from "@heroui/react";
import { LimeInput } from "./LimeInput";
import { t } from "@lingui/core/macro";
import { api } from "@/lib/api-client";
import { GetLookupCompanyData } from "@/server-types";
import { ScanSearch } from "lucide-react";
import { cn } from "@/utils";

export const CompanyLookupInput = ({
  label,
  taxNumber,
  onValueChange,
  onLookupSuccess,
  error,
  isSuccess,
}: {
  label?: string;
  taxNumber: string;
  onValueChange: (taxNumber: string) => void;
  onLookupSuccess?: (companyData: GetLookupCompanyData["response"]) => void;
  error?: string | React.ReactNode;
  /** Marks the field green once a lookup has filled the form. */
  isSuccess?: boolean;
}) => {
  const {
    mutateAsync: getLookupCompanyData,
    isPending: isFetchingCompanyData,
    processedErrorMessage: getLookupCompanyDataErrorMessage,
  } = api.external.useGetLookupCompanyData();

  return (
    <LimeInput
      label={label ?? t`Davčna številka podjetja`}
      variant="bordered"
      value={taxNumber}
      onValueChange={onValueChange}
      data-identifier="company-tax-number"
      error={error}
      classNames={
        isSuccess && error == null
          ? { inputWrapper: "border-success data-[hover=true]:border-success" }
          : undefined
      }
      endContent={
        onLookupSuccess ? (
          <Button
            isIconOnly
            variant="bordered"
            className={cn("h-full", {
              "border-danger text-danger":
                error != null || getLookupCompanyDataErrorMessage != null,
            })}
            type="button"
            onPress={async () => {
              try {
                const companyData = await getLookupCompanyData(taxNumber);
                onLookupSuccess?.(companyData);
              } catch {
                // useCustomMutation toasts the failure; rethrowing would only
                // surface as an unhandled rejection.
              }
            }}
            isDisabled={taxNumber.length === 0}
            isLoading={isFetchingCompanyData}
          >
            <ScanSearch />
          </Button>
        ) : null
      }
    />
  );
};
